"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_STATE = void 0;
const Actions = __importStar(require("../actions/types"));
exports.DEFAULT_STATE = {
    classes: {
        allIds: [],
        byId: {},
        v2TerminalIds: [],
        v2Ids: [],
        inUseTerminalNodes: [],
    },
    isRefresh: false,
    isLoading: false,
};
const taxonomyClassesSetData = (state, { payload }) => (Object.assign(Object.assign({}, state), { classes: Object.assign(Object.assign({}, state.classes), payload) }));
const taxonomyClassesSetInUseTerminaNodes = (state, { payload }) => (Object.assign(Object.assign({}, state), { classes: Object.assign(Object.assign({}, state.classes), { inUseTerminalNodes: payload }) }));
exports.default = (state = exports.DEFAULT_STATE, action) => {
    switch (action.type) {
        case Actions.TAXONOMY_CLASSES_SET_DATA:
            return taxonomyClassesSetData(state, action);
        case Actions.TAXONOMY_CLASSES_SET_IS_LOADING:
            return Object.assign(Object.assign({}, state), { isLoading: action.payload.isLoading });
        case Actions.TAXONOMY_CLASSES_REFRESH:
            return Object.assign(Object.assign({}, state), { isRefresh: action.payload });
        case Actions.TAXONOMY_CLASSES_SET_IN_USE_TERMINAL_NODES:
            return taxonomyClassesSetInUseTerminaNodes(state, action);
        default:
            return state;
    }
};
